import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default {
  init() {
    // JavaScript to be fired on the about us page
    this.loader = document.querySelector('[data-archive-loader]');

    console.log('this', this.loader);
    this.loaderCircle = this.loader.querySelector('[data-loader-circle]');
    this.currentPage = 1;
    this.onEnter = this.onEnter.bind(this);
    this.list = document.querySelector('[data-archive-list]');
    this.listType = this.list.getAttribute('data-archive-list-type');
    this.listCategory = this.list.getAttribute('data-archive-list-category');
    this.typeFilter = this.list.getAttribute('data-types-filter');
    this.listTag = this.list.getAttribute('data-archive-list-tag');
    this.searchTerm = this.list.getAttribute('data-search-term');
    this.initScrollTrigger();
  },
  initScrollTrigger() {
    ScrollTrigger.batch(this.loader, {
      onEnter: this.onEnter,
      scrub: true,
    });
  },
  onEnter() {
    if (this.isLoading || this.currentPage === this.totalPages) {
      return;
    }

    this.isLoading = true;
    this.currentPage++;
    const nonce = document.querySelector('[name="csrf-token"]').content;
    this.loader.style.display = 'block';
    const loaderAnim = gsap.to(this.loaderCircle, {
      duration: 5,
      opacity: 1,
      strokeDashoffset: 799,
      paused: true,
    });
    loaderAnim.play();
    const data = {
      page: parseInt(this.currentPage),
      postType: this.listType || 'post',
      action: 'archives_ajax',
      nonce,
    };

    if (this.listCategory) {
      data.category = this.listCategory;
    }

    if (this.listTag) {
      data.tag = this.listTag;
    }

    if (this.listTag && this.typeFilter) {
      data.postType = this.typeFilter;
    }

    if (this.searchTerm) {
      data.searchInput = this.searchTerm;
    }

    fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({ ...data }),
    })
      .then((response) => response.json())
      .then((data) => {
        loaderAnim.pause().progress(0);
        const divEl = document.createElement('div');
        divEl.innerHTML = data.posts_html;
        divEl.childNodes.forEach((child) => {
          this.list.appendChild(child);
        });
        this.totalPages = data.max_page;
        ScrollTrigger.update();
        ScrollTrigger.refresh();
        this.isLoading = false;
        if (this.totalPages === this.currentPage) {
          this.loader.style.display = 'none';
        }
      });
  },
};
